import { api } from '@api'
import { FetchParams, PaginatedResponse } from './types'
import { usePaginate } from './usePaginate'
import { Contact } from './types/contactTypes'

const fetchHashtagContacts = async ({ pageParam = '1', id }: FetchParams): Promise<PaginatedResponse<Contact>> => {
  const url = `/hashtags/${id}/contacts?page=${pageParam}`
  const { data } = await api.get<PaginatedResponse<Contact>>(url)
  return data
}

export const usePaginateHashtagContacts = (id: string) => {
  return usePaginate<Contact>('hashtag-contacts', fetchHashtagContacts, { id }, { enabled: !!id })
}
